export const ANIMAL_TYPE_ID_UNDEFINED = -1;

export type AnimalType = {
  Id: number;
  Name: string;
  VenomCodeId: number;
  IsVisible: number;
};
